module.exports = __webpack_public_path__ + "media/images/how_second-775edce995ea8b9e4558d4a12f83ea16.svg";